import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";

type Response = {
  success: boolean;
  now: string;
};

export const triggerPullGames = async () => {
  const fn = httpsCallable<void, Response>(functions, "triggerPullGames");
  const response = await fn();
  return response.data;
};
